import { RUB } from '../../../utils/char';
import { useTranslation } from '../../../utils/useTranslation';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { themeColorMap } from '../ProductMonetization/constants';
import { CurrencyIcon, BadgeLabel } from '../ProductMonetization/styles';
import { ProductMonetizationProps } from '../ProductMonetization/types';

export const ProductMonetizationPlainText: React.FC<ProductMonetizationProps> = ({
    color,
    ...props
}) => {
    const t = useTranslation();

    const themeColor = themeColorMap[color];

    return (
        <Box {...props}>
            <Flex direction="row" alignItems="center" spacing={0.5}>
                <CurrencyIcon backgroundColor={themeColor.color} color={themeColor.backgroundColor}>
                    {RUB}
                </CurrencyIcon>
                <BadgeLabel pt="2px" color={themeColor.color}>
                    {t('Есть монетизация')}
                </BadgeLabel>
            </Flex>
        </Box>
    );
};
